import React from 'react';

export interface CreateIconOptions {
    displayName: string;
    viewBox: string;
    path: React.ReactNode | React.ReactNode[];
    [key: string]: any;
}

export type IconComponentType = React.ForwardRefExoticComponent<
    React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & React.RefAttributes<SVGSVGElement>
>;

export function createIcon({
    displayName,
    viewBox,
    path,
    ...rest
}: CreateIconOptions): IconComponentType {
    const IconComponent = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
        <svg
            aria-label={displayName}
            fill="currentColor"
            ref={ref}
            viewBox={viewBox}
            {...rest}
            {...props}
        >
            {path}
        </svg>
    ));
    IconComponent.displayName = displayName;

    return IconComponent;
}